import Image from 'next/image';
import { useContext } from 'react';
import { MPosContext } from 'utils/context';
import { getImageBasePath } from 'utils/generics';
import Header from 'widgets/header';
import * as Styles from './styles';

function ContactUs() {
    const { setShowHamburger } = useContext(MPosContext);

    const onBack = () => {
        setShowHamburger(true);
    };

    return (
        <Styles.Wrapper>
            <Header />
            <Styles.Header>
                <Styles.BackArrowIcon>
                    <Image
                        width={'10px'}
                        height={'24px'}
                        alt={''}
                        src={getImageBasePath('/icons/backArrow.svg')}
                        onClick={onBack}
                    />
                </Styles.BackArrowIcon>
            </Styles.Header>
            <Styles.ContactUsTitle>Contact us</Styles.ContactUsTitle>
            <Styles.Text>{`We’re here to help you - all day, from 8 AM to 10 PM. Choose one to talk with our in-house team:`}</Styles.Text>
            <Styles.ContactFlex>
                <Styles.Label>Email</Styles.Label>
                <Styles.Value>mpossupport@acko.com</Styles.Value>
            </Styles.ContactFlex>
        </Styles.Wrapper>
    );
}

export default ContactUs;
